import { Link, useNavigate } from "react-router-dom";
import { FaMagnifyingGlass } from "react-icons/fa6";
import WRGGHomeLogo from "./WRGGHomeLogo";
import Seo from "./Seo";
import { blackButtonSurfaceClass, buttonFocusRingClass, neutralButtonSurfaceClass } from "../shared/buttonStyles";

function NotFound404() {
  const navigate = useNavigate();

  return (
    <div className="my-10 rounded-lg px-4 pt-2 pb-2 flex flex-col items-center h-[70vh] mb-[250px] w-full">
      <Seo
        title="Page Not Found | WINRATES.GG™"
        description="The page you requested could not be found on WINRATES.GG™."
        robots="noindex, nofollow"
      />
      {/* Logo / Top */}
      <div className="text-center mb-4 mt-9 mx-9 flex flex-col flex-[.3] justify-center items-center rounded-lg leading-none h-44 w-44">
        <WRGGHomeLogo className="h-44 w-44 opacity-90" />
      </div>

      {/* Card */}
      <div className="mt-2 min-w-[300px] max-w-[768px] w-full">
        <div className="bg-zinc-950/78 border border-zinc-700 rounded-lg p-6 sm:p-8">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="inline-flex items-center gap-2 text-xs font-semibold text-cyan-200 bg-cyan-900/20 border border-cyan-700/40 rounded-md px-2 py-1">
                <span className="h-2 w-2 rounded-full bg-cyan-400" />
                PAGE NOT FOUND
              </div>

              <h1 className="mt-4 text-3xl sm:text-4xl font-bold text-zinc-100 tracking-tight">
                404
              </h1>

              <p className="mt-2 text-sm sm:text-base text-zinc-400 max-w-prose">
                That route doesn’t exist (or it moved). If you typed the URL,
                double-check it — otherwise head back home and search a summoner.
              </p>
            </div>

            <div className="hidden sm:block text-right">
              <div className="text-xs text-zinc-400">WINRATES.GG</div>
              <div className="text-xs text-zinc-600">β</div>
            </div>
          </div>

          {/* Actions */}
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link
              to="/"
              className={`inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-semibold transition-colors ${buttonFocusRingClass} ${neutralButtonSurfaceClass}`}
            >
              Go to Home
            </Link>

            <button
              onClick={() => navigate("/")}
              className={`inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition-colors ${buttonFocusRingClass} ${blackButtonSurfaceClass}`}
              type="button"
            >
              <FaMagnifyingGlass className="h-4 w-4" />
              Search a Summoner
            </button>

            <button
              onClick={() => navigate(-1)}
              className={`inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-semibold transition-colors ${buttonFocusRingClass} ${neutralButtonSurfaceClass}`}
              type="button"
            >
              Go Back
            </button>
          </div>

          {/* Small hint */}
          <div className="mt-6 text-xs text-zinc-400 border-t border-zinc-800 pt-4">
            Tip: Try <span className="text-zinc-300">[NA] - Doublelift#NA01</span>
          </div>
        </div>

        {/* Footer note */}
        <div className="flex flex-col justify-center items-center text-zinc-400 w-full max-w-[450px] mx-auto mt-6 text-xs px-4">
          <div className="text-center">
            League of Legends® content belongs to Riot Games®.
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound404;
